import { isAlphanumericAllSpecialCharacters, isAlphanumericAllSpecialCharactersDashPlusMinusDegree } from "../../../functions/validations";
import PropTypes from 'prop-types';
import { GenericTable } from "../../utility/common/TransactionComponents/GenericTable";
import { bluestyle, errorstyle } from "../../../functions/welding-functions";

export const errorstatus = (error, columns, type) => {
  let status = false
  columns.map((column) => {
    if (column.field === 'SFA' || column.field === 'Classification' || column.field === 'ANo' || column.field === 'FNo' || column.field === 'ChemicalAnalysis_TradeName') {
      if (error[`WPSD_${type}_${column.field}`] && error[`WPSD_${type}_${column.field}`].status) {
        status = true
      }
    }
  })
  return status
}

export const errormessage = (error, columns, type) => {
  let message = ""
  columns.map((column) => {
    if (column.field === 'SFA' || column.field === 'Classification' || column.field === 'ANo' || column.field === 'FNo' || column.field === 'ChemicalAnalysis_TradeName') {
      if (error[`WPSD_${type}_${column.field}`] && error[`WPSD_${type}_${column.field}`].message) {
        message = error[`WPSD_${type}_${column.field}`].message
      }
    }
  })
  return message
}

export const PQR_Filler_metals = ({
  detailObj,
  setdetailObj,
  disabled,
  error,
  setError,
  handleChangedetailsarray,
  SfaActive,
  FnoActive,
  AnoActive,
  disableFields,
  setIsEdited
}) => {
  PQR_Filler_metals.propTypes = {
    detailObj: PropTypes.object,
    setdetailObj: PropTypes.func,
    handleChangedetailsarray: PropTypes.func,
    error: PropTypes.object,
    setError: PropTypes.func,
    disabled: PropTypes.bool,
    disableFields: PropTypes.bool,
    SfaActive: PropTypes.array,
    FnoActive: PropTypes.array,
    AnoActive: PropTypes.array,
    setIsEdited: PropTypes.func
  };

  const columns = [
    {
      header: '',
      field: 'blank',
      type: 'label',
      textalign: "left",
      width: "10px",
      className: "thead-color-white"
    },
    {
      header: 'Process',
      field: 'process',
      type: 'text',
      textalign: "left",
      width: "30px"
    },
    {
      header: 'SFA',
      field: 'SFA',
      type: 'dropdown',
      valueField: 'wld_code',
      labelField: 'wld_code',
      align: "left",
      width: "80px",
      textalign: "left"
    },
    {
      header: "Classification",
      field: 'Classification',
      type: 'input',
      inputWidth: '350px',
      maxLength: 12,
      validator: isAlphanumericAllSpecialCharactersDashPlusMinusDegree,
      className: "WpsInput",
      textalign: "left",
      width: "200px"
    },
    {
      header: "F.No.",
      field: 'FNo',
      type: 'dropdown',
      valueField: 'wld_code',
      labelField: 'wld_code',
      align: "left",
      textalign: "left",
      width: "100px"
    },
    {
      header: 'A.No.',
      field: 'ANo',
      type: 'dropdown',
      validator: isAlphanumericAllSpecialCharacters,
      valueField: 'wld_code',
      labelField: 'wld_code',
      className: "WpsInput",
      textalign: "left",
      width: "100px"
    },
    {
      header: 'Chemical Analysis or TradeName',
      field: 'ChemicalAnalysis_TradeName',
      type: 'input',
      validator:  isAlphanumericAllSpecialCharactersDashPlusMinusDegree,
      inputWidth: "350px",
      maxLength: 50,
      className: "WpsInput",
      textalign: "left",
      width: "380px"
    },
  ];

  const tableData = {
    rows: [
      {
        blank: { value: '' },
        process: { value: "GTAW" },
        SFA: { value: detailObj?.WPSD_FM_SFA, field: "WPSD_FM_SFA", error: error["WPSD_FM_SFA"]?.status },
        Classification: { value: detailObj?.WPSD_FM_Classification, field: "WPSD_FM_Classification", error: error["WPSD_FM_Classification"]?.status },
        FNo: { value: detailObj?.WPSD_FM_FNo, field: "WPSD_FM_FNo", error: error["WPSD_FM_FNo"]?.status },
        ANo: { value: detailObj?.WPSD_FM_Ano, field: "WPSD_FM_Ano", error: error["WPSD_FM_Ano"]?.status },
        ChemicalAnalysis_TradeName: { value: detailObj?.WPSD_FM_ChemicalAnalysis_TradeName, field: "WPSD_FM_ChemicalAnalysis_TradeName", error: error["WPSD_FM_ChemicalAnalysis_TradeName"]?.status },
        hasError: errorstatus(error, columns, "FM"),
        errorMessage: errormessage(error, columns, "FM")
      },
    ]
  };

  return (
    <GenericTable
      data={tableData}
      columns={columns}
      isReadonly={disabled}
      handleChange={handleChangedetailsarray}
      setError={setError}
      setData={setdetailObj}
      errorStyle={errorstyle}
      defaultStyle={bluestyle}
      disableFields={disableFields}
      dropdownData={{
        SFA: [SfaActive],
        FNo: [FnoActive],
        ANo: [AnoActive]
      }}
      setIsEdited={setIsEdited}
    />
  );
};
